<template>
  <div>

    <hr>
    <div class="container-fluid px-0">
      <div class="row">
        <div class="col-xs-12 col-md-12">
          <h3 class="text-left">Leave Attendance Reports for Flexible Working Hours</h3>
          <p class="text-left">
              <span class="font-weight-normal">
                  This report shows detailed daily and monthly leave attendance reports for flexible working hours.
              </span>
          </p>
        </div>
      </div>
      <div class="row pb-2 mb-2 px-3 mt-3">

        <!-- <div class="col-xs-6 col-md-6 d-flex">
          <div class="stats-info flex-fill">
            <h6 class="text-left">Daily Attendance</h6>
            <hr>
            <p class="text-left">
              <span class="font-weight-normal">
                  This report shows detailed daily attendance report of employees.
              </span>
            </p>
            <div class="mt-2">
              <div class="d-flex justify-content-start">
                <b-button @click="$bvModal.show('bv-modal-la-daily-attendance-report')"> View Report</b-button>
              </div>
            </div>
          </div>
        </div> -->
        <div class="col-md-4 pl-0">
            <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                <img :src="$api_url+'/images/Monthly_Payroll_Report.png'">
                <h5>Daily Attendance</h5>
                <p>This report shows detailed daily attendance report of employees.</p>
                <b-button @click="$bvModal.show('bv-modal-la-daily-attendance-report')"> View Report</b-button>
            </div>
        </div>

        <!-- <div class="col-xs-6 col-md-6 d-flex">
          <div class="stats-info flex-fill">
            <h6 class="text-left">Monthly Attendance Summary</h6>
            <hr>
            <p class="text-left">
              <span class="font-weight-normal">
                  This report provides a summarized view of each employee’s attendance status for the month, including total present days, absences, leaves, holidays, and weekends.
              </span>
            </p>
            <div class="mt-1">
              <div class="d-flex justify-content-start">
                <b-button @click="$bvModal.show('bv-modal-la-monthly-attendance-summary')" > View Report</b-button>
              </div>
            </div>
          </div>
        </div> -->
        <div class="col-md-4">
            <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                <img :src="$api_url+'/images/Monthly_Payroll_Report.png'">
                <h5>Monthly Attendance Summary</h5>
                <p>This report provides a summarized view of each employee’s attendance status for the month, including total present days, absences, leaves, holidays, and weekends.</p>
                <b-button @click="$bvModal.show('bv-modal-la-monthly-attendance-summary')"> View Report</b-button>
            </div>
        </div>

        <!-- <div class="col-xs-6 col-md-6 d-flex">
          <div class="stats-info flex-fill">
            <h6 class="text-left">Monthly Attendance Report</h6>
            <hr>
            <p class="text-left">
              <span class="font-weight-normal">
                  This report displays a detailed breakdown of each employee's daily attendance status for the entire month, showing presence, absence, leave types, and holidays.
              </span>
            </p>
            <div class="mt-2">
              <div class="d-flex justify-content-start">
                <b-button @click="$bvModal.show('bv-modal-la-monthly-attendance-report')"> View Report</b-button>
              </div>
            </div>
          </div>
        </div> -->

        <div class="col-md-4 pr-0">
            <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                <img :src="$api_url+'/images/Monthly_Payroll_Report.png'">
                <h5>Monthly Attendance Report</h5>
                <p>This report displays a detailed breakdown of each employee's daily attendance status for the entire month, showing presence, absence, leave types, and holidays.</p>
                <b-button @click="$bvModal.show('bv-modal-la-monthly-attendance-report')"> View Report</b-button>
            </div>
        </div>

        <!-- <div class="col-xs-6 col-md-6 d-flex">
          <div class="stats-info flex-fill">
            <h6 class="text-left">Monthly In/Out Report</h6>
            <hr>
            <p class="text-left">
              <span class="font-weight-normal">
                  This report shows the daily clock-in and clock-out times of employees for the month, helping to track punctuality and work patterns.
              </span>
            </p>
            <div class="mt-1">
              <div class="d-flex justify-content-start">
                <b-button @click="$bvModal.show('bv-modal-la-monthly-in-out-report')"> View Report</b-button>
              </div>
            </div>
          </div>
        </div> -->

        <div class="col-md-4 pl-0 mt-4">
            <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                <img :src="$api_url+'/images/Monthly_Payroll_Report.png'">
                <h5>Monthly In/Out Report</h5>
                <p>This report shows the daily clock-in and clock-out times of employees for the month, helping to track punctuality and work patterns.</p>
                <b-button @click="$bvModal.show('bv-modal-la-monthly-in-out-report')"> View Report</b-button>
            </div>
        </div>

        <!-- <div class="col-xs-6 col-md-6 d-flex">
          <div class="stats-info flex-fill">
            <h6 class="text-left">Monthly Working Hour Report</h6>
            <hr>
            <p class="text-left">
              <span class="font-weight-normal">
                  This report calculates the total working hours of each employee for the month, including daily in/out durations and total hours worked.
              </span>
            </p>
            <div class="mt-1">
              <div class="d-flex justify-content-start">
                <b-button @click="$bvModal.show('bv-modal-la-working-hour-report')"> View Report</b-button>
              </div>
            </div>
          </div>
        </div> -->

        <div class="col-md-4 mt-4">
            <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                <img :src="$api_url+'/images/Monthly_Payroll_Report.png'">
                <h5>Monthly Working Hour Report</h5>
                <p>This report calculates the total working hours of each employee for the month, including daily in/out durations and total hours worked.</p>
                <b-button @click="$bvModal.show('bv-modal-la-working-hour-report')"> View Report</b-button>
            </div>
        </div>

        <!-- <div class="col-xs-6 col-md-6 d-flex">
          <div class="stats-info flex-fill">
            <h6 class="text-left">Single Person Report</h6>
            <hr>
            <p class="text-left">
              <span class="font-weight-normal">
                  This report presents the complete attendance record of a selected employee for a specified month, including in/out times, attendance status, and total hours worked.
              </span>
            </p>
            <div class="mt-1">
              <div class="d-flex justify-content-start">
                <b-button @click="$bvModal.show('bv-modal-la-single-person-report')"> View Report</b-button>
              </div>
            </div>
          </div>
        </div> -->

      </div>

    </div>


    <b-modal id="bv-modal-la-daily-attendance-report" dialog-class="modal-xxl" size="xl" scrollable hide-footer title="Daily Attendance Report">
      <l-a-daily-report > </l-a-daily-report>
    </b-modal>
    <b-modal id="bv-modal-la-monthly-attendance-summary" dialog-class="modal-xxl" size="xl" scrollable hide-footer title="Monthly Attendance Summary">
      <l-a-monthly-report :flag="1"> </l-a-monthly-report>
    </b-modal>
    <b-modal id="bv-modal-la-monthly-attendance-report" dialog-class="modal-xxl" size="xl" scrollable hide-footer title="Monthly Attendance Report">
      <l-a-monthly-report :flag="2"> </l-a-monthly-report>
    </b-modal>
    <b-modal id="bv-modal-la-monthly-in-out-report" dialog-class="modal-xxl" size="xl" scrollable hide-footer title="Monthly In/Out Report">
      <l-a-monthly-report :flag="3"> </l-a-monthly-report>
    </b-modal>
    <b-modal id="bv-modal-la-working-hour-report" dialog-class="modal-xxl" size="xl" scrollable hide-footer title="Monthly Working Hour Report">
      <l-a-monthly-report :flag="4"> </l-a-monthly-report>
    </b-modal>
    <b-modal id="bv-modal-la-single-person-report" dialog-class="modal-xxl" size="xl" scrollable hide-footer title="Single Person Report">
      <l-a-single-person-report > </l-a-single-person-report>
    </b-modal>
    <div>

    </div>
  </div>
</template>
<script>
export default{

  mounted() {
  },
  props: [],
  components: {

  },
  data(){
    return {
    }
  },
  methods:{
  },
  created(){
  }
}
</script>
<style scoped>
.modal-lg, .modal-xl {
  max-width: 2000px !important;
}

.modal-xxl {
  height: 100vh;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
}

.modal-xxl .modal-content {
  flex-grow: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.modal-xxl .modal-body {
  flex-grow: 1;
  overflow-y: auto;
}
</style>
